module.exports = __webpack_public_path__ + "static/atrennes-ad7d3f9c7ff3332304e6fa6676576033.png";